;(function () {
  angular
    .module('contrast.application')
    .directive('csAppLink', ['$filter', 'UserService', csAppLink])

  function csAppLink($filter, UserService) {
    return {
      replace: true,
      restrict: 'E',
      bindToController: {
        app: '=',
        cut: '='
      },
      controller: controller,
      controllerAs: 'appLinkCtrl',
      templateUrl: 'views/common/app_link.html'
    }

    function controller() {
      var vm = this

      function init() {
        _getCurrentOrganization()

        if (angular.isArray(vm.cut) && angular.isDefined(vm.app)) {
          vm.app.name = $filter('cut').apply(vm, [vm.app.name].concat(vm.cut))
        }
      }

      function _getCurrentOrganization() {
        vm.organization = UserService.getCurrentOrganization()
      }

      init()
    }
  }
})()
